import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class FundChartAISummaryService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    saveSummary(calc, startDate, endDate, securityId, textContent, prompt) {
        const params = {
            calc,
            start_date: startDate,
            end_date: endDate,
            security_id: securityId,
            text_content: textContent,
            prompt,
        };
        return this.ajaxService.postDataObserveBody(this.urlsService.AI_CHAT.FIND_FUND_CHART_AI_SUMMARY, params);
    }
}
FundChartAISummaryService.ɵfac = function FundChartAISummaryService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartAISummaryService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
FundChartAISummaryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FundChartAISummaryService, factory: FundChartAISummaryService.ɵfac, providedIn: 'root' });
